module.exports = __webpack_public_path__ + "static/media/img13.b81c3cfe.jpeg";